module.exports = __webpack_public_path__ + "static/35-c14f5a3023b3f788ab2785ceb738e498.jpg";